function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { useEffect as d, useRef as s } from "react";
import { FocusableMode as p, isFocusableElement as C } from '../utils/focus-management.js';
import { useDocumentEvent as a } from './use-document-event.js';

function L(m, E) {
  var c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
  var i = s(!1);
  d(function () {
    requestAnimationFrame(function () {
      i.current = c;
    });
  }, [c]);

  function f(e, o) {
    if (!i.current || e.defaultPrevented) return;

    var l = function r(t) {
      return typeof t == "function" ? r(t()) : Array.isArray(t) || t instanceof Set ? t : [t];
    }(m),
        n = o(e);

    if (n !== null && n.getRootNode().contains(n)) {
      var _iterator = _createForOfIteratorHelper(l),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var r = _step.value;
          if (r === null) continue;
          var t = r instanceof HTMLElement ? r : r.current;
          if (t != null && t.contains(n) || e.composed && e.composedPath().includes(t)) return;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return !C(n, p.Loose) && n.tabIndex !== -1 && e.preventDefault(), E(e, n);
    }
  }

  var u = s(null);
  a("mousedown", function (e) {
    var o, l;
    i.current && (u.current = ((l = (o = e.composedPath) == null ? void 0 : o.call(e)) == null ? void 0 : l[0]) || e.target);
  }, !0), a("click", function (e) {
    u.current && (f(e, function () {
      return u.current;
    }), u.current = null);
  }, !0), a("blur", function (e) {
    return f(e, function () {
      return window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null;
    });
  }, !0);
}

export { L as useOutsideClick };